type SectionPosition = { id: string; top: number; bottom: number };
type ScrollPosition = { scrollY: number; viewportHeight: number; documentHeight: number; navigationHeight: number };

export function portalSectionAtScroll(sections: SectionPosition[], position: ScrollPosition): string | null {
  const first = sections[0];
  const last = sections.at(-1);
  if (!first || !last) return null;

  const { scrollY, viewportHeight, documentHeight, navigationHeight } = position;
  let readingLine = Math.min(navigationHeight + 80, viewportHeight * 0.45);
  const maxScroll = Math.max(0, documentHeight - viewportHeight);
  const lastHeadingAtBottom = last.top + scrollY - maxScroll;

  // Near the page end, move the reading line gradually towards the last heading.
  // Short sections can then become active even when they cannot reach the sticky tabs.
  if (maxScroll > 0 && lastHeadingAtBottom >= readingLine) {
    const tailStart = Math.min(maxScroll - 1, Math.max(0, first.top + scrollY - readingLine, maxScroll - viewportHeight * 0.8));
    const progress = Math.max(0, Math.min(1, (scrollY - tailStart) / (maxScroll - tailStart)));
    readingLine += (Math.min(viewportHeight - 1, lastHeadingAtBottom + 1) - readingLine) * progress;
  }

  return sections.findLast(({ top }) => top <= readingLine)?.id ?? first.id;
}
